var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analyze"},[_c('el-row',[_c('el-col',{attrs:{"span":3}},[_c('span',{staticClass:"h3"},[_vm._v(_vm._s(_vm.$t('shu_ju_dao_chu')))])])],1),_c('export',{staticClass:"analyze-data"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }